module.exports = __webpack_public_path__ + "media/images/mailer/icon-instagram-footer-5b5dde40be10108335c31d37595247bf.svg";